import React, { useState } from "react";
import "./LocationPopUpModal.css";
import { MdLocationOn, MdClose } from "react-icons/md";

const LocationPopUpModal = ({ onAllow, onManual, onClose, errorMessage }) => {
  const [guide, setGuide] = useState(null);

  const detectDevice = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) return "android";
    if (/iphone|ipad|ipod/.test(ua)) return "ios";
    return "desktop";
  };

  const handleEnableLocation = () => {
    const device = detectDevice();
    setGuide(device);
    onAllow && onAllow(); // still trigger your location detection function if needed
  };

  const renderGuide = () => {
    switch (guide) {
      case "android":
        return (
          <div className="location-popup-guide">
            <h4>📱 Enable Location on Android (Chrome)</h4>
            <ul>
              <li>1️⃣ Open <b>Settings → Apps → Chrome → Permissions</b>.</li>
              <li>2️⃣ Tap <b>Location</b> and select <b>Allow</b>.</li>
              <li>3️⃣ Refresh this page and try again.</li>
            </ul>
          </div>
        );

      case "ios":
        return (
          <div className="location-popup-guide">
            <h4>🍎 Enable Location on iPhone (Safari)</h4>
            <ul>
              <li>1️⃣ Go to <b>Settings → Safari → Location</b>.</li>
              <li>2️⃣ Choose <b>Ask</b> or <b>Allow</b>.</li>
              <li>3️⃣ Reopen Safari and refresh this page.</li>
            </ul>
          </div>
        );

      case "desktop":
      default:
        return (
          <div className="location-popup-guide">
            <h4>💻 Enable Location on Desktop Browser</h4>
            <ul>
              <li>1️⃣ Click the <b>🔒 Lock icon</b> next to the address bar.</li>
              <li>2️⃣ Choose <b>Site Settings → Location → Allow</b>.</li>
              <li>3️⃣ Refresh this page and try again.</li>
            </ul>
          </div>
        );
    }
  };

  return (
    <div className="location-popup-wrapper">
      <div className="location-popup-card">
        {/* Close Button */}
        <button className="location-popup-close" onClick={onClose}>
          <MdClose />
        </button>

        <div className="location-popup-illustration">
          <div className="pin-bg">
            <MdLocationOn className="pin-icon" />
          </div>
          <div className="pin-bubble">?</div>
        </div>

        <div className="location-popup-text">
          <h2>We don’t have your location, yet!</h2>
          <p>Set your location to start exploring events and venues near you.</p>

          {errorMessage && (
            <p className="location-popup-error">{errorMessage}</p>
          )}

          <button className="location-btn-primary" onClick={handleEnableLocation}>
            📍 Enable device location
          </button>

          <p className="location-popup-note">
            We only access your location while you are using the app to improve your experience.
          </p>

          {guide && renderGuide()}

        
        </div>
      </div>
    </div>
  );
};

export default LocationPopUpModal;
